import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class HelpService {
    constructor(private apiService: ApiService) {}

    submitSupportRequest(supportRequestInfo: any): Observable<any> {
        return this.apiService.put(`/support`, supportRequestInfo);
    }
}
